import { cn } from "@/utils/cn";
import type { IAdvisor } from "../types";

interface AdvisorGlyphProps {
  advisor: IAdvisor;
  isActive?: boolean;
  className?: string;
}

/** The advisor's icon in a tile — shared by the dropdown rows and triggers. */
export const AdvisorGlyph = ({
  advisor,
  isActive,
  className,
}: AdvisorGlyphProps) => {
  const Icon = advisor.icon;
  return (
    <span
      aria-hidden="true"
      className={cn(
        "flex size-7 shrink-0 items-center justify-center rounded-md",
        isActive ? "bg-surface text-primary" : "bg-muted text-muted-foreground",
        className,
      )}
    >
      <Icon className="size-4" />
    </span>
  );
};
